import { Button, Col, Row } from 'antd';
import React from 'react';
import { withRouter } from 'react-router-dom';
import * as etiquetas from '../../ApplicationResources';
import HeaderModule from '../interfaz/Elements/HeaderModule';
import TemplateExterno from '../interfaz/TemplateExterno';
import iconEmail from '../../img/icons/Correo.svg';
import iconJDE from '../../img/icons/JDE.svg';
import { ReactSVG } from 'react-svg'
import { redireccionar } from '../../utils/funciones';


class NoRecibiCorreo extends React.Component {
    constructor(props) {
        super(props);
    }

    redireccionarEnvioCorreo = () => {
        this.props.history.push('/modifica_correo');
    }

    redireccionarContacto = () => {
        this.props.history.push('/contacto_jde');
    }

    render() {
        return(
            <TemplateExterno enlaces={true}>
                <Row>
                    <Col sm={24} md={24} lg={24}>
                        <HeaderModule title={etiquetas.contacto_label_no_recibi_correo} />
                    </Col>
                </Row>
                <Row>
                    <Col sm={24} md={24} lg={24} className='contacto_title_principal'>
                        {etiquetas.contacto_label_selecciona_una_opcion}
                    </Col>
                </Row>
                <Row gutter={[32, 16]}>
                    <Col sm={24} md={12} lg={12} className='contacto_columna_1'>
                        <Button type="primary"
                                className="contacto_boton_no_recibi_correo"
                                onClick={this.redireccionarEnvioCorreo}
                                >
                            <div id='content'>
                                <div id='labelTitle'>
                                    {etiquetas.contacto_button_label_solicitar_correo}
                                </div>
                                <div>
                                    <img src={iconEmail} />
                                </div>
                                <div id='labelDescription'>
                                    {etiquetas.contacto_button_label_solicitar_correo_description}
                                </div>
                            </div>
                        </Button>
                    </Col>
                    <Col sm={24} md={12} lg={12} className='contacto_columna_2'>
                        <Button type="primary"
                                className="contacto_boton_no_recibi_correo"
                                onClick={this.redireccionarContacto}
                                >
                            <div id='content'>
                                <div id='labelTitle'>
                                    {etiquetas.contacto_button_label_consultar_junta}
                                </div>
                                <div>
                                    <img src={iconJDE} />
                                </div>
                                <div id='labelDescription'>
                                    {etiquetas.contacto_button_label_consultar_junta_description}
                                </div>
                            </div>
                        </Button>
                    </Col>
                </Row>
            </TemplateExterno>
        );
    }
};

export default withRouter(NoRecibiCorreo);